export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Communications';
export const TEAM_NAME = 'Alexstrasza';
